import { requestTimeout } from '../lib/helper';
import { elHTML } from '../config/vars';

export default class FormSubfields {

  constructor(el) {

    this.el = el;
    // currently only for input[type="checkbox"]
    this.trigger = this.el.querySelector('input:not([type="hidden"])');
    this.targets = document.querySelectorAll(this.el.getAttribute('data-target-subfields'));
    this.targetsLength = (this.targets) ? this.targets.length : 0;
    this.isEditData = this.trigger.form.classList.contains('tc-edit-data');
    this.toggleTargets = document.querySelectorAll(this.el.getAttribute('data-toggle-subfields'));
    this.toggleTargetsLength = (this.toggleTargets) ? this.toggleTargets.length : 0;

    this.trigger.addEventListener('change', this.updateSubfieldsVisibility.bind(this), false);

    for (let i = 0; i < this.targetsLength; i++) {

      this.targets[i].fields = [].slice.call(this.targets[i].querySelectorAll('input, select, textarea'));
    }

    for (let i = 0; i < this.toggleTargetsLength; i++) {

      this.toggleTargets[i].fields = [].slice.call(this.toggleTargets[i].querySelectorAll('input, select, textarea'));
    }

    if (elHTML.classList.contains('is-ie-9')) {

      requestTimeout(this.updateSubfieldsVisibility.bind(this), 10);
    } else {

      this.updateSubfieldsVisibility();
    }
  }

  updateSubfieldsVisibility(e) {

    if (this.trigger.checked) {

      this.show();
    } else {

      this.hide();
    }
  }

  show() {

    for (let i = 0; i < this.targetsLength; i++) {

      this.targets[i].style.display = '';

      if (!this.isEditData || this.trigger.form.classList.contains('is-active')) {
        this.targets[i].fields.map(field => {
          field.disabled = false;
          return field;
        });
      }
    }

    for (let i = 0; i < this.toggleTargetsLength; i++) {

      this.toggleTargets[i].style.display = 'none';

      if (!this.isEditData || this.trigger.form.classList.contains('is-active')) {
        this.toggleTargets[i].fields.map(field => {
          field.disabled = true;
          return field;
        });
      }
    }
  }

  hide() {

    for (let i = 0; i < this.targetsLength; i++) {

      this.targets[i].style.display = 'none';

      if (!this.isEditData || this.trigger.form.classList.contains('is-active')) {
        this.targets[i].fields.map(field => {
          field.disabled = true;
          return field;
        });
      }
    }

    for (let i = 0; i < this.toggleTargetsLength; i++) {

      this.toggleTargets[i].style.display = '';

      if (!this.isEditData || this.trigger.form.classList.contains('is-active')) {
        this.toggleTargets[i].fields.map(field => {
          field.disabled = false;
          return field;
        });
      }
    }
  }
};
